import { DatabaseModel, ModelJson } from './database-model';

export class Payment extends DatabaseModel {
    // Amount / price payed by customer
    public amount: number = 0;
    // Stripe client id
    public clientId: string;
    // Timestamp when payment was created
    public createdOn: number;
    // Stripe customer id
    public customer: string;
    // Unique payment key / id 
    public key: string = '';
    // Stripe checkout object type
    public object: string;
    // Stripe payment intent id
    public intent: string;

    /**
     * Construct a payment info object and call DatabaseModel super constructor
     */
    constructor(key: string = '', json: any = null) {
        super();
        if(key) this.key = key;
        if(json) this.fromJson(json);
    }

    /**
     * Create model instance from json text (deserialize)
     */
    public fromJson(json: ModelJson): Payment {
        Object.assign(this, json);
        return this;
    }

    /**
     * Serialize model to json text
     */
    public toJson(): any {
        let json = Object.assign({}, this);
        return json;
    }
}
